import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import { getByUser, getUserAll, getTeamByCompany } from './core/cacheService'
export default {
    namespaced: true,
    state: {
      teams:[],
      teamsfixed: [],
      teamsall:[],
      teamsfixedall: [],
      teamsfixedall_temp: [],
      inputSearch: '',
      organization1level: {},
    },
    mutations: {
        setTeams(state:any, result:any) {
            state.teams = result
        },
        setTeamsFixed(state:any, result:any) {
            state.teamsfixed = result
        },
        setTeamsAll(state:any, result:any) {
            state.teamsall = result
        },
        setTeamsFixedAll(state:any, result:any) {
            state.teamsfixedall = result
        },
        setTeamsFixedAll_Temp(state:any, result:any) {
            state.teamsfixedall_temp = result
        },
        setinputSearch(state:any,value:any) {
            state.inputSearch = value.value
        },
        setOrganization1level(state:any, result:any) {
            state.organization1level = result
        },
    },
    actions: {
        getTeamsOptions({dispatch,state}:any, user:any){
            if(state.teamsall.length ==0){
                dispatch('getTeams',user)
            }
        },
        getTeamsOptionsFixed({dispatch,state}:any, user:any){
            if(state.teamsfixedall.length ==0){
                dispatch('getTeamsFixed',user)
            }
        },
        async getTeamsFixed({commit,dispatch,state,rootState}:any, user:any){
            const allUser = await getUserAll(user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
            const organization1level = {}
            if(user.user_type == 'leadership'){
                if(user.email){
                    const emailKey = user.email.replace(/\./g, '||')
                    var userData = await getByUser(user.email)//(await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
                }
                
                if(userData){
                    await firebase.firestore().collection('organization1level').where("company", "==", userData.company).where("team_id","==",userData.team).get()
                    .then((querySnapshot)=> {
                        if(querySnapshot.empty){
                            organization1level[userData.team] = true
                        }else{
                            querySnapshot.forEach((doc)=> {
                                _.forEach(doc.data().parent, function(_,key) {
                                    organization1level[key] = true
                                });
                            });
                        }
                        commit('setOrganization1level', organization1level)
                    });
                }
            }
            let allTeam:any
                allTeam = {}
            const teams:Array<any> = [];
            const teams_temp:Array<any> = [];
            let chk_teams_master:Array<any> = [];
            const parent:{ [key: string]: string} = {};
            const teamData = await getTeamByCompany(user.company)
            for(const key in teamData){
                const team = teamData[key]
                    team.key = key
                    team.key_temp = key
                    team.value = team.name
                    if(user.user_type == 'leadership'){
                        if(organization1level[team.key]){
                            teams.push(team)
                        }
                    }else{
                        teams.push(team)
                    }
                    
                    teams_temp[team.key] = team
                    allTeam[team.key] = team
                    if(key) parent[key] = team.name


            }

            _.forEach(teams, (value,key)=> {
                if(value.parent){
                    teams[key].parent_name = parent[value.parent]
                    teams_temp[value.key].parent_name = parent[value.parent]
                }else{
                    teams[key].parent_name = '';
                    teams_temp[value.key].parent_name = '';
                    if(chk_teams_master['count'] == undefined){
                        chk_teams_master['count'] = 1
                    }else{
                        chk_teams_master['count'] += 1
                    }
                    if(chk_teams_master['team'] == undefined){
                        chk_teams_master['team'] = new Array()
                    }
                    chk_teams_master['team'].push(value.key)
                }
            });
            if(chk_teams_master['count'] == 1){
                let chkUser = _.filter(allUser, { 'team': chk_teams_master['team'][0] });
                if(chkUser.length > 0){
                    commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
                    commit('setTeamsFixedAll_Temp', teams_temp)
                    commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
                    if(state.inputSearch){
                        dispatch('searchTeamsFixed',state.inputSearch)
                    }
                }else{
                    let chkTeam:any = _.filter(allTeam, { 'parent': chk_teams_master['team'][0] });
                    if(chkTeam && chkTeam.length > 0){
                        const chkTeamNextLevel:Array<any> = [];
                        let chkCount = 0
                        _.forEach(chkTeam, (value, key) => {
                            chkTeamNextLevel.push(value.key)
                        });
                        if(chkTeamNextLevel.length == 1){
                            for(const x in teams_temp){
                                if(chk_teams_master['team'][0] == teams_temp[x].key){
                                    teams_temp[x].key_temp = chkTeamNextLevel[0]
                                }
                            }
                        }else{
                            const chkUserInTeam:Array<any> = [];
                            _.forEach(chkTeamNextLevel, (value, key) => {
                                let chkUser = _.filter(allUser, { team: value });
                                if(chkUser.length > 0){
                                    chkUserInTeam.push(value)
                                    chkCount++
                                }
                            });
                            if(chkCount == 1){
                                for(const x in teams_temp){
                                    if(chk_teams_master['team'][0] == teams_temp[x].key){
                                        teams_temp[x].key_temp = chkUserInTeam[0]
                                    }
                                }
                            }
                        }
                        commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
                        commit('setTeamsFixedAll_Temp', teams_temp)
                        commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
                        if(state.inputSearch){
                            dispatch('searchTeamsFixed',state.inputSearch)
                        }
                    }else{
                        commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
                        commit('setTeamsFixedAll_Temp', teams_temp)
                        commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
                        if(state.inputSearch){
                            dispatch('searchTeamsFixed',state.inputSearch)
                        }
                    }
                }
                // if(chk_teams_master['team'][0])
            }else{
                commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
                commit('setTeamsFixedAll_Temp', teams_temp)
                commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
                if(state.inputSearch){
                    dispatch('searchTeamsFixed',state.inputSearch)
                }
            }
            // firebase.database().ref().child('team').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
            //     let allTeam:any
            //     allTeam = {}
            //     const teams:Array<any> = [];
            //     const teams_temp:Array<any> = [];
            //     let chk_teams_master:Array<any> = [];
            //     const parent:{ [key: string]: string} = {};
            //     snapshot.forEach((doc):any => {
            //         const team = doc.val()
            //         team.key = doc.key
            //         team.key_temp = doc.key
            //         team.value = doc.val().name
            //         if(user.user_type == 'leadership'){
            //             if(organization1level[team.key]){
            //                 teams.push(team)
            //             }
            //         }else{
            //             teams.push(team)
            //         }
                    
            //         teams_temp[team.key] = team
            //         allTeam[team.key] = team
            //         if(doc.key) parent[doc.key] = doc.val().name
            //     });
            //     _.forEach(teams, (value,key)=> {
            //         if(value.parent){
            //             teams[key].parent_name = parent[value.parent]
            //             teams_temp[value.key].parent_name = parent[value.parent]
            //         }else{
            //             teams[key].parent_name = '';
            //             teams_temp[value.key].parent_name = '';
            //             if(chk_teams_master['count'] == undefined){
            //                 chk_teams_master['count'] = 1
            //             }else{
            //                 chk_teams_master['count'] += 1
            //             }
            //             if(chk_teams_master['team'] == undefined){
            //                 chk_teams_master['team'] = new Array()
            //             }
            //             chk_teams_master['team'].push(value.key)
            //         }
            //     });
            //     if(chk_teams_master['count'] == 1){
            //         let chkUser = _.filter(allUser, { 'team': chk_teams_master['team'][0] });
            //         if(chkUser.length > 0){
            //             commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //             commit('setTeamsFixedAll_Temp', teams_temp)
            //             commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //             if(state.inputSearch){
            //                 dispatch('searchTeamsFixed',state.inputSearch)
            //             }
            //         }else{
            //             let chkTeam:any = _.filter(allTeam, { 'parent': chk_teams_master['team'][0] });
            //             if(chkTeam && chkTeam.length > 0){
            //                 const chkTeamNextLevel:Array<any> = [];
            //                 let chkCount = 0
            //                 _.forEach(chkTeam, (value, key) => {
            //                     chkTeamNextLevel.push(value.key)
            //                 });
            //                 if(chkTeamNextLevel.length == 1){
            //                     for(const x in teams_temp){
            //                         if(chk_teams_master['team'][0] == teams_temp[x].key){
            //                             teams_temp[x].key_temp = chkTeamNextLevel[0]
            //                         }
            //                     }
            //                 }else{
            //                     const chkUserInTeam:Array<any> = [];
            //                     _.forEach(chkTeamNextLevel, (value, key) => {
            //                         let chkUser = _.filter(allUser, { team: value });
            //                         if(chkUser.length > 0){
            //                             chkUserInTeam.push(value)
            //                             chkCount++
            //                         }
            //                     });
            //                     if(chkCount == 1){
            //                         for(const x in teams_temp){
            //                             if(chk_teams_master['team'][0] == teams_temp[x].key){
            //                                 teams_temp[x].key_temp = chkUserInTeam[0]
            //                             }
            //                         }
            //                     }
            //                 }
            //                 commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //                 commit('setTeamsFixedAll_Temp', teams_temp)
            //                 commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //                 if(state.inputSearch){
            //                     dispatch('searchTeamsFixed',state.inputSearch)
            //                 }
            //             }else{
            //                 commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //                 commit('setTeamsFixedAll_Temp', teams_temp)
            //                 commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //                 if(state.inputSearch){
            //                     dispatch('searchTeamsFixed',state.inputSearch)
            //                 }
            //             }
            //         }
            //         // if(chk_teams_master['team'][0])
            //     }else{
            //         commit('setTeamsFixed', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //         commit('setTeamsFixedAll_Temp', teams_temp)
            //         commit('setTeamsFixedAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //         if(state.inputSearch){
            //             dispatch('searchTeamsFixed',state.inputSearch)
            //         }
            //     }
            // }).catch(error => {
            //     console.log(error)
            // });
        },
        async getTeams({commit,dispatch,state,rootState}:any, user:any){
            const organization1level = {}
            if(user.user_type == 'leadership'){
                if(user.email){
                    const emailKey = user.email.replace(/\./g, '||')
                    var userData =await getByUser(user.email)// (await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
                }
                if(userData){
                    await firebase.firestore().collection('organization1level').where("company", "==", userData.company).where("team_id","==",userData.team).get()
                    .then((querySnapshot)=> {
                        if(querySnapshot.empty){
                            organization1level[userData.team] = true
                        }else{
                            querySnapshot.forEach((doc)=> {
                                _.forEach(doc.data().parent, function(_,key) {
                                    organization1level[key] = true
                                });
                            });
                        }
                        commit('setOrganization1level', organization1level)
                    });
                }
            }
            try{
                const teams:Array<any> = [];
                const parent:{ [key: string]: string} = {};
                const teamData = await getTeamByCompany(user.company)
                for(const key in teamData){
                    const team = teamData[key]
                    team.key = key
                    team.value = teamData[key].name
                    if(user.user_type == 'leadership'){
                        if(organization1level[team.key]){
                            teams.push(team)
                            if(key) parent[key] = teamData[key].name
                        }
                    }else{
                        teams.push(team)
                        if(key) parent[key] = team.name
                    }
                  
                }

                _.forEach(teams, (value,key)=> {
                    if(value.parent){
                        teams[key].parent_name = parent[value.parent]
                    }else{
                        teams[key].parent_name = '';
                    }
                });
                commit('setTeams', _.sortBy(teams, [function(o:any) { return o.name; }]))
                commit('setTeamsAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
                if(state.inputSearch){
                    dispatch('searchTeams',state.inputSearch)
                }
                
            }catch(error){
                console.log(error)
            }
            // firebase.database().ref().child('team').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
            //     const teams:Array<any> = [];
            //     const parent:{ [key: string]: string} = {};
            //     snapshot.forEach((doc):any => {
            //         const team = doc.val()
            //         team.key = doc.key
            //         team.value = doc.val().name
            //         if(user.user_type == 'leadership'){
            //             if(organization1level[team.key]){
            //                 teams.push(team)
            //                 if(doc.key) parent[doc.key] = doc.val().name
            //             }
            //         }else{
            //             teams.push(team)
            //             if(doc.key) parent[doc.key] = doc.val().name
            //         }
            //     });
            //     _.forEach(teams, (value,key)=> {
            //         if(value.parent){
            //             teams[key].parent_name = parent[value.parent]
            //         }else{
            //             teams[key].parent_name = '';
            //         }
            //     });
            //     commit('setTeams', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //     commit('setTeamsAll', _.sortBy(teams, [function(o:any) { return o.name; }]))
            //     if(state.inputSearch){
            //         dispatch('searchTeams',state.inputSearch)
            //     }
            // }).catch(error => {
            //     console.log(error)
            // });
        },
        searchTeams({commit,state}:any,value:string){
            var re = new RegExp(value, 'gi')
            var response = _.filter(state.teamsall, (item):any => {
                if (item.name.match(re)){
                    return true
                }else if(item.parent_name!=undefined && item.parent_name.match(re)){
                    return true
                }
            });
            commit('setTeams',response)
        },
        searchTeamsFixed({commit,state}:any,value:string){
            var re = new RegExp(value, 'gi')
            var response = _.filter(state.teamsfixedall, (item):any => {
                if (item.name.match(re)){
                    return true
                }else if(item.parent_name!=undefined && item.parent_name.match(re)){
                    return true
                }
            });
            commit('setTeamsFixed',response)
        },
        updateTeam({commit,rootState,dispatch}:any,value:any){
            firebase.database().ref(`/team/${value.id}`).update({
                name:value.name,
                parent:value.parent,
                updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: value.id,
                    table: 'team',
                    status: 'edit',
                    user: rootState.authen.user.email
                }, {root:true}).then(function() {
                    dispatch('getTeams',rootState.authen.user)
                });
            });
        },
        createTeam({commit,rootState,dispatch}:any,value:any){
            const newId = firebase.database().ref('team').push().key;
            firebase.database().ref(`team/${newId}`).update({
                name:value.name,
                parent:value.parent,
                company:rootState.authen.user.company,
                updated:format(new Date(), 'YYYY-MM-DD HH:mm')
            }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: newId,
                    table: 'team',
                    status: 'add',
                    user: rootState.authen.user.email
                }, {root:true}).then(function() {
                    dispatch('getTeams',rootState.authen.user)
                });
            });
        },
        deleteTeam({commit,rootState,dispatch}:any,key:any){
            firebase.database().ref(`/team/${key}`).remove().then(()=>{
                dispatch('getTeams',rootState.authen.user)
            }).then(()=>{
                firebase.database().ref(`/genorganize`).push({
                    company:rootState.authen.user.company
                });
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: key,
                    table: 'team',
                    status: 'remove',
                    user: rootState.authen.user.email
                }, {root:true}).then(function() {
                    dispatch('getTeams',rootState.authen.user)
                });
            });
        }
    },
    getters: {
        teamsall: (state:any) => {
            return state.teamsall
        },
        teamsfixedall: (state:any) => {
            return state.teamsfixedall
        },
        teamsfixedall_temp: (state:any) => {
            return state.teamsfixedall_temp
        },
        teams : (state:any) => {
            return state.teams
        },
        teamsfixed : (state:any) => {
            return state.teamsfixed
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        }
    }
  }